<script lang="ts">
    import {_} from 'svelte-i18n'
    import Button from '@smui/button';
    import {Label} from '@smui/common';
    import {contextService, definedMessageService} from './services';
    import type {DefinedMessage} from './types';
    import {DefinedMessageType} from './types';
    import {onMount} from 'svelte';
    import NonHtmlDefinedMessageEditor from './NonHtmlDefinedMessageEditor.svelte';
    import {v4} from 'uuid';

    export let type: DefinedMessageType;

    let definedMessages: DefinedMessage[] = [];

    function addNew() {
        const newDefinedMessage: DefinedMessage = {
            id: v4(),
            contextId: contextService.getResolvedContextId(),
            type: type,
            html: false,
            text: '',
        };
        definedMessages = [...definedMessages, newDefinedMessage];
    }

    async function saveMessage(event: CustomEvent<DefinedMessage>) {
        await definedMessageService.save(event.detail);
        await refreshMessages();
    }

    async function removeMessage(event: CustomEvent<DefinedMessage>) {
        await definedMessageService.remove(event.detail);
        await refreshMessages();
    }

    async function moveUp(definedMessage: DefinedMessage) {
        definedMessages = await definedMessageService.moveUp(definedMessage, definedMessages);
    }

    async function moveDown(definedMessage: DefinedMessage) {
        definedMessages = await definedMessageService.moveDown(definedMessage, definedMessages);
    }

    async function refreshMessages() {
        definedMessages = await definedMessageService.getOfType(type);
    }

    onMount(async () => await refreshMessages());
</script>

<div>
    {#each definedMessages as definedMessage, index (definedMessage.id)}
        <div style="margin: 20px 0; display: flex; align-items: center; gap: 8px;">
            <div style="display: flex; flex-direction: column;">
                <button type="button" on:click={() => moveUp(definedMessage)} disabled={index === 0}>▲</button>
                <button type="button" on:click={() => moveDown(definedMessage)} disabled={index === definedMessages.length - 1}>▼</button>
            </div>
            <div style="flex: 1;">
                <NonHtmlDefinedMessageEditor definedMessage={definedMessage}
                                             on:save={saveMessage}
                                             on:remove={removeMessage} />
            </div>
        </div>
    {/each}
    <div style="margin: 20px 0;">
        <Button type="button" on:click={addNew} variant="unelevated">
            <Label>{$_('commons.AddNext')}</Label>
        </Button>
    </div>
</div>